import React from 'react';
import SignUpForm from './SignUpForm';
import LoginForm from './LoginForm';
import { connect } from 'react-redux';
import PasswordRecoverForm from './PasswordRecoverForm';
import AuthDialogConstants from './AuthDialogConstants';
import { DialogActions, Dialog, DialogContent, Grid } from '@mui/material';
import DialogCloseButton from '../../buttons/DialogCloseButton';
import ColoredSnackbarConstants from '../../misc/ColoredSnackbar/ColoredSnackbarConstants';
import { appOperations } from '../../../App/store';

const AuthDialog = (props) => {
    const {
        formType,
        authDialogOpen,
        authDialogRequesting,
        refreshMethod,
        setAuthDialogFormType,
        closeAuthDialog,
        login,
        signUp,
        recoverPassword,
        openSnack
    } = props;

    const displayError = (message) => openSnack(message, ColoredSnackbarConstants.SNACKBAR_ERROR);

    let content;
    switch (formType) {
        case AuthDialogConstants.FORM_TYPE_SIGN_UP:
            content = <SignUpForm
                setFormType={setAuthDialogFormType}
                signUp={(email, password, agreeTerms, allowEmails, reCaptchaCode) =>
                    signUp(email, password, agreeTerms, allowEmails, reCaptchaCode, refreshMethod)}
                requesting={authDialogRequesting}
                displayError={displayError}
            />
            break;
        case AuthDialogConstants.FORM_TYPE_LOGIN:
            content = <LoginForm
                setFormType={setAuthDialogFormType}
                login={(email, password) => login(email, password, refreshMethod)}
                requesting={authDialogRequesting}
            />
            break;
        case AuthDialogConstants.FORM_TYPE_RESET:
            content = <PasswordRecoverForm
                setFormType={setAuthDialogFormType}
                recoverPassword={recoverPassword}
                requesting={authDialogRequesting}
            />
            break;
        default:
            content = <LoginForm
                setFormType={setAuthDialogFormType}
                login={(email, password) => login(email, password, refreshMethod)}
                requesting={authDialogRequesting}
            />
    }

    return (
        <Dialog
            open={authDialogOpen}
            onClose={closeAuthDialog}
            maxWidth='xs'
            fullWidth={true}
            aria-labelledby='auth-dialog-label'
        >
            <DialogContent>
                <DialogCloseButton
                    onClick={closeAuthDialog}
                />
                <Grid
                    container
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                    spacing={2}
                    style={{ display: 'block' }}
                >
                    {content}
                </Grid>
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

const mapStateToProps = (state) => {
    const {
        authDialogOpen,
        authDialogFormType,
        authDialogRequesting,
        refreshMethod
    } = state.app;

    return {
        authDialogOpen,
        formType: authDialogFormType,
        authDialogRequesting,
        refreshMethod
    }
}

const mapDispatchToProps = (dispatch) => {
    const closeAuthDialog = () => dispatch(appOperations.closeAuthDialog());
    const setAuthDialogFormType = (formType) => dispatch(appOperations.setAuthDialogFormType(formType));
    const login = (email, password, refreshMethod) => dispatch(appOperations.login(email, password, refreshMethod));
    const signUp = (email, password, agreeTerms, allowEmails, reCaptchaCode, refreshMethod) => dispatch(appOperations.signUp(email, password, agreeTerms, allowEmails, reCaptchaCode, refreshMethod));
    const recoverPassword = (email) => dispatch(appOperations.recoverPassword(email));
    const openSnack = (text, variant) => dispatch(appOperations.openSnack(text, variant));

    return {
        closeAuthDialog,
        setAuthDialogFormType,
        login,
        signUp,
        recoverPassword,
        openSnack
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthDialog);